import { snakify } from '@/helpers/common';
import { request } from './base';

type TInfo = Record<string, unknown>;

export interface IUserStorageItem<T = TInfo> {
  identifier: string;
  info: T;
}

export interface IUserStorageItemRecord<T = TInfo> extends IUserStorageItem<T> {
  createdAt: string;
  updatedAt: string;
}

interface IUserStorageItemsResponse<T = TInfo> {
  data: IUserStorageItemRecord<T>[];
}

export const getUserStorageItems = <T = TInfo>() =>
  request<IUserStorageItemsResponse<T>>({ url: 'user_storage_items' });

export const saveUserStorageItems = (items: IUserStorageItem[]) =>
  request<IUserStorageItemsResponse>({
    method: 'POST',
    url: 'user_storage_items',
    data: snakify({ data: items }),
  });

export const deleteUserStorageItems = (identifiers: string[]) =>
  request<null>({
    method: 'POST',
    url: 'user_storage_items/delete',
    data: { data: identifiers },
  });
